// Service để gửi form data lên Google Apps Script API
const FORM_API_URL =
  'https://script.google.com/macros/s/AKfycbzmperY3MFMILhlpWCgMf_85cPnnkFvUgn2sTG3M6ixcXlEa-r-bpKr3STw3_DWZ9KC/exec';

// Gửi form data lên Google Apps Script
export const submitFormData = async (formData) => {
  try {
    // Chuẩn bị dữ liệu theo format API yêu cầu
    const apiData = {
      hoten_gui: formData.sharedName || '',
      sdt_gui: formData.sharedPhone || '',
      hoten_nhan: formData.recipientName || '',
      sdt_nhan: formData.recipientPhone || '',
      tinh_tp: formData.provinceName || '',
      xa_phuong: formData.wardName || '',
      so_nha: formData.street || '',
      noidung: formData.story || '',
      hinhanh: formData.imageUrls || [], // URLs từ Cloudinary
      video: formData.videoUrls || [], // URLs từ Cloudinary
    };

    const response = await fetch(FORM_API_URL, {
      method: 'POST',
      mode: 'no-cors', // Sử dụng no-cors để tránh CORS error
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(apiData),
    });

    // Với no-cors mode, response sẽ bị opaque và không thể đọc được
    // Chúng ta coi như request đã thành công nếu không có exception
    console.log('Request sent successfully');

    // Vì không thể đọc response với no-cors, chúng ta coi như thành công
    // Google Apps Script sẽ xử lý dữ liệu và lưu vào Google Sheets
    return {
      success: true,
      message: 'Thông tin của bạn đã được tiếp nhận',
      data: { status: 'success' },
    };
  } catch (error) {
    console.error('Error submitting form:', error);
    return {
      success: false,
      message: 'Có lỗi xảy ra. Vui lòng liên hệ CSKH',
      error: error,
    };
  }
};

// Upload files lên server (deprecated - sử dụng cloudinaryService thay thế)
export const uploadFiles = async (files) => {
  // Deprecated: Sử dụng cloudinaryService.uploadImage() và cloudinaryService.uploadVideo() thay thế
  console.warn('uploadFiles is deprecated. Use cloudinaryService instead.');
  return files.map((file) => ({
    name: file.name,
    url: file.preview, // Tạm thời dùng preview URL
  }));
};
